import React from 'react';
import { Body, BodyProps } from '@hover/blueprint';

interface Props extends BodyProps {
  content: string;
}

const ScreenReaderText: React.FC<Props> = ({ content, ...rest }) => (
  <Body
    position="absolute"
    left="-10000px"
    width="1px"
    heigth="1px"
    top="auto"
    overflow="hidden"
    {...rest}
  >
    {content}
  </Body>
);

export default ScreenReaderText;
